module.exports = __webpack_public_path__ + "img/3.de256a9c.jpg";